import React, { useEffect } from "react";
import { SelectMenu, CustomLabel } from "@focus/focusUI";
import { useState } from "react";
export const MultiEditSelector = ({ config, onChange }) => {
    const options = config.map(conf => conf.label);
    const [value, setValue] = useState(options[0]);
    const updateValue = newValue => {
        setValue(newValue);
        onChange(newValue);
    };
    useEffect(() => updateValue(options[0]), []);
    return (React.createElement(CustomLabel, { inline: true, text: "Target" },
        React.createElement(SelectMenu, { options: options, value: value, onChange: updateValue })));
};
//# sourceMappingURL=MultiEditSelector.js.map